export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

// export const LOGO_URL =
//     "https://www.pngall.com/wp-content/uploads/8/Burger-Restaurant-PNG-Free-Download.png"

export const LOGO_URL = "../assets/swadish-logo.png";

export const MENU_API_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9613042&lng=80.2355167&restaurantId=";
